import React from 'react';
import styled from 'styled-components';
import {
  breakpointSizes,
  fluidFontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container } from './ui';
import BeeBadge from './BeeBadge';
import PlanCard from './PlanCard';

const StyledPlanListing = styled.section`
  ${sectionPaddings()};
  background-color: ${standardColours.lightGrey};
`;

const StyledInner = styled.div`
  position: relative;
`;

const StyledHeader = styled.header`
  margin: 0 auto 40px;
  max-width: 900px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 50px;
    width: 90%;
  `}

  ${minBreakpointQuery.medium`
    margin-bottom: 70px;
    width: 75%;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 90px;
    width: 60%;
  `}

  ${minBreakpointQuery.xxlarge`
    margin-bottom: 110px;
  `}
`;

const StyledHeading = styled.h1`
  ${fluidFontSize(
    '42px',
    '80px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge,
  )};
  line-height: 1;
`;

const StyledText = styled.p`
  margin-top: 20px;
  ${fluidFontSize(
    '16px',
    '30px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge,
  )};

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.small`
    row-gap: 30px;
  `}

  ${minBreakpointQuery.large`
    grid-template-columns: repeat(6, 1fr);
  `}

  ${minBreakpointQuery.xxlarge`
    row-gap: 40px;
  `}
`;

const StyledItem = styled(PlanCard)`
  ${minBreakpointQuery.large`
    grid-column: span 2;
  `}

  &:nth-child(-n+2) {
    ${minBreakpointQuery.large`
      grid-column: span 3;
    `}
  }
`;

const StyledBadge = styled(BeeBadge)`
  ${maxBreakpointQuery.large`
    margin: 60px auto auto;
  `}

  ${maxBreakpointQuery.small`
    margin-top: 40px;
  `}

  ${minBreakpointQuery.large`
    position: absolute;
    top: 0;
    right: 0;
    max-width: 180px;
    transform: translateY(-25%);
  `}

  ${minBreakpointQuery.xxlarge`
    max-width: 210px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    max-width: 240px;
  `}
`;

const PlanListing = ({ heading, text, items }) => (
  <StyledPlanListing>
    <Container>
      <StyledInner>
        <StyledHeader>
          <StyledHeading>{heading}</StyledHeading>
          {text && <StyledText>{text}</StyledText>}
        </StyledHeader>
        <StyledItems>
          {items.map((item, id) => (
            <StyledItem key={id} {...item} />
          ))}
        </StyledItems>
        <StyledBadge alt={true} />
      </StyledInner>
    </Container>
  </StyledPlanListing>
);

export default PlanListing;
